<template>
  <HeaderTrade />

     <!-- Container Start { -->
     <div id="container" class="sts-trade-container">
       <!-- Contents Start { -->
       <div id="contents">

        <TradeTopNav 
          :pid="route.params.id"
        />

        <div class="chart-info-inner">
          <TopItemInfo v-if="selectItem"
            :selectItem="selectItem"
            :pid="route.params.id"
          /> 
        </div>

         <!-- content start -->
         <div class="contents-area order-contents">           
           <div class="trade-order-contents">
             <!-- left :: 호가 화면 start -->
             <div class="trade-order-left">
               <!-- 호가창 시작  -->
                <HtsTrade v-if="selectItem && selectItem.TYPE!='G'"
                  :selectItem="selectItem"  
                   @change-select-price = "onChangeSelectPrice"                    
                />
                <HtsTradeCF v-else-if="selectItem && selectItem.TYPE=='G'"
                  :selectItem="selectItem"  
                   @change-select-price = "onChangeSelectPrice"                   
                />
               <!-- //호가창 종료 -->            
             </div>
             <!-- //left :: 호가 화면 end -->
             <!-- right :: 주문 화면 start -->
             <div class="trade-order-right">  
               <TradeOrderContainerM v-if="selectItem && selectItem.TYPE!='G'"
                 :selectItem="selectItem" 
                 :currentSelectOrderPrice="currentSelectPrice"
                 :startOrderType="startOrderType"
               />
               <TradeOrderContainerMCF v-else-if="selectItem && selectItem.TYPE=='G'"
                 :selectItem="selectItem" 
                 :currentSelectOrderPrice="currentSelectPrice"
                 :startOrderType="startOrderType"
               />
             </div>
             <!-- //right :: 주문 화면 end -->
           </div>
         </div>
         <!-- // content end -->
         <TradeBottomNav
            :id="route.params.id"
          />

       </div>
       <!-- } Contents End -->
     </div>
     <!-- } Container End -->
     <OrderModal v-if="selectItem"
        :selectItem="selectItem"
      />
     <AlertModal />

</template>

<script>
import { useStore } from 'vuex';
import HeaderTrade from '@/components/HeaderTrade.vue';
import TradeTopNav from "@/components/TradeTopNav.vue"
import TradeBottomNav from "@/components/TradeBottomNav.vue"
import {useRoute }from 'vue-router'
import { onMounted, onUnmounted, computed, ref, getCurrentInstance} from 'vue'
import HtsTrade from '@/components/trade/HtsTrade.vue';
import HtsTradeCF from '@/components/trade/coinFutures/HtsTrade_cf.vue';

import TradeOrderContainerM from '@/components/trade/TradeOrderContainerM.vue';
import TradeOrderContainerMCF from '@/components/trade/coinFutures/TradeOrderContainerM_cf.vue';
import TopItemInfo from '@/components/trade/TopItemInfo.vue';


import { useScoket } from '@/socket';
import {useGetItemList, useBalance, useSpaceId} from '@/composables/vtradeFn';

import OrderModal from '@/components/trade/OrderModal.vue';
import AlertModal from '@/components/trade/AlertModal.vue';

export default {
   components:{   
       HeaderTrade,
       TradeTopNav,
       TradeBottomNav,
       HtsTrade,
       HtsTradeCF,
       TradeOrderContainerM,
       TradeOrderContainerMCF,
       OrderModal,
       AlertModal,
       TopItemInfo,
   },   
   setup(){
  
    const store = useStore();
    const route = useRoute();
    const {socket} = useScoket(); 
    const {setCurrentSpaceId, setCurrentSpaceIdForEvent} = useSpaceId();

    const {setCurrentBalance} = useBalance(); 
    store.commit('trade/CHANGE_CURRENT_PAGE_BOTTOM', 'tradeArea'); 
    store.commit('trade/CHANGE_CURRENT_PAGE_ID', 'navi_0'); 


          


    const  {getItemByCode} = useGetItemList()
    const emitter = getCurrentInstance().appContext.config.globalProperties.emitter;
    const currentTradeType = computed(() => store.state.hts.currentTradeType);
    
    if(currentTradeType.value == 'S')store.commit('common/CHANGE_CURRENT_PAGE', 'TradeStock');  
    else if(currentTradeType.value == 'F')store.commit('common/CHANGE_CURRENT_PAGE', 'TradeFutures');  
    else if(currentTradeType.value == 'C')store.commit('common/CHANGE_CURRENT_PAGE', 'TradeCoin');  
    else if(currentTradeType.value == 'G')store.commit('common/CHANGE_CURRENT_PAGE', 'TradeCoinFutures');  
 


    console.log("route ~~~~: ", route.params)

    const selectItem = ref(null)

    const currentSelectPrice = ref(store.state.hts.currentOrderData?store.state.hts.currentOrderData.price:1)     
    const startOrderType = ref(store.state.hts.currentOrderData?store.state.hts.currentOrderData.order_type:'1');

    if(route.params.id == '0')
    {
      store.commit('trade/CHANGE_CURRENT_LEAGUETYPE', 'normal');
      setCurrentSpaceId(currentTradeType.value);
      store.commit('trade/CHANGE_CURRENT_PAGE_ID', 'navi_0'); 
    }
    else
    {
      store.commit('trade/CHANGE_CURRENT_LEAGUETYPE', 'event');
      setCurrentSpaceIdForEvent(currentTradeType.value, route.params.id);
      store.commit('trade/CHANGE_CURRENT_PAGE_ID', 'navi_eventLeague_trade'); 
    }



   // setCurrentSpaceId(currentTradeType.value);
    emitter.on('EVENT_INIT_TRADE_FOR_SPACE', (obj) => {
        //console.log("bbbbbbbbbbbbbbbbbbbbb:", )
        emitter.off('EVENT_INIT_TRADE_FOR_SPACE');    
        if(obj == null)
        {
          store.commit('hts/CHANGE_SPACE_ID', -1);
        }
        else
        {
          store.commit('hts/CHANGE_SPACE_ID', obj.id);    
          if(store.state.hts.currentSpaceId != null &&  store.state.hts.currentSpaceId != -1 )
          {
                setCurrentBalance(store.state.hts.currentSpaceId);  
                store.dispatch('hts/getOrderList');
                store.dispatch('hts/getAssetList');
          }     

        }       
    })


    onMounted(async ()=>{ 
      console.log("getAssetList:",store.state.hts.currentSpaceId )
      store.commit('hts/CHANGE_ORDERBOOK', []);
      store.commit('hts/CHANGE_INIT_TEADE', []);  
      // if(store.state.hts.currentSpaceId != null &&  store.state.hts.currentSpaceId != -1 )
      // {
      //       setCurrentBalance(store.state.hts.currentSpaceId);  
      //       store.dispatch('hts/getOrderList');
      //       store.dispatch('hts/getAssetList');
      // }      
      selectItem.value = await getItemByCode(currentTradeType.value, route.params.code); 

     
      var _isNight = false;
      if(selectItem.value.TYPE == 'F')
      {         
         if(selectItem.value.isNight  && String(selectItem.value.isNight) == 'true') 
         { 
            selectItem.value.CODE = selectItem.value.CODE.split('_')[0];                        
            _isNight = true;           
         }        
      }
  
      store.commit('hts/CHANGE_CURRENT_ITEM', selectItem.value);    
      
      socket.emit("requestInit", {
          itemType: selectItem.value.TYPE,
          code: selectItem.value.CODE,
          isNight:_isNight        
      }, function(e) {  
          console.log("requestInit:",  e) 
          setTimeout(()=>{
            socket.emit("requestCode", {
                  itemType:selectItem.value.TYPE,
                  code:selectItem.value.CODE,
                  isNight:_isNight
                }, function() { 
                  console.log("requestCode:", selectItem.value.CODE, _isNight)    
                })     
            },500)
         })
      })

      onUnmounted(()=>{          
          socket.emit("leaveCode", {
              itemType:  selectItem.value.TYPE,
              code: selectItem.value.CODE,
              isNight:selectItem.value.isNight?selectItem.value.isNight:false                    
          }, function() { 
            //  console.log("leaveCode:",  selectItem.CODE)    
          })                
      })

      const onChangeSelectPrice = (price) =>{
            //console.log("onPriceClick :", Number(price));
            currentSelectPrice.value = Number(price);
            
      }
      return{
      selectItem,
      onChangeSelectPrice,
      currentSelectPrice,
      startOrderType,
      route
      }
   }
}
</script>

<style>

</style>